import { render } from "./KOT.vue?vue&type=template&id=0681ccd8&scoped=true"
import script from "./KOT.vue?vue&type=script&lang=js"
export * from "./KOT.vue?vue&type=script&lang=js"

import "./KOT.vue?vue&type=style&index=0&id=0681ccd8&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0681ccd8"]])

export default __exports__